import { SET_APP_CONFIGS, SetAppConfigsAction } from '../types'

const initialState = {}

const customReportConfigReducer = (state = initialState, action: SetAppConfigsAction) => {
  switch (action.type) {
    case SET_APP_CONFIGS:
      return action.payload.customReport
    default:
      return state
  }
}

export default customReportConfigReducer
